import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import AudioRecorder from "../../../pages/AudioRecorder";

const AudioRecorderModal = ({ isOpen, onClose, data, onDataChange, userRole }) => {
  const [liveTranscriptText, setLiveTranscriptText] = useState("");

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "LIVE_TRANSCRIPT_UPDATE") {
        console.log("[AudioRecorderModal] postMessage received:", event.data.text?.slice(0, 60));
        setLiveTranscriptText(event.data.text || "");
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // localStorage fallback for when postMessage doesn't reach the parent
  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === "liveTranscriptUpdate" && event.newValue) {
        try {
          const parsed = JSON.parse(event.newValue);
          if (parsed?.text) setLiveTranscriptText(parsed.text);
        } catch (_) {}
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  useEffect(() => {
    console.log("[AudioRecorderModal] isOpen changed:", isOpen);
    if (!isOpen) setLiveTranscriptText("");
  }, [isOpen]);

  console.log("[AudioRecorderModal] rendering — isOpen:", isOpen, "liveTranscriptText length:", liveTranscriptText.length);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent width="50%" maxWidth="none" maxH="90vh">
        <ModalHeader>Record Audio</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={4}>
          <Tabs>
            <TabList>
              <Tab>Recorder</Tab>
              <Tab>Live Transcript</Tab>
            </TabList>
            <TabPanels>
              <TabPanel p={0} pt={3}>
                <AudioRecorder state={data} onDataChange={onDataChange} userRole={userRole} />
              </TabPanel>
              <TabPanel>
                <Box
                  p={3}
                  bg="gray.50"
                  borderRadius="md"
                  minH="200px"
                  whiteSpace="pre-wrap"
                  fontSize="sm"
                  color={liveTranscriptText ? "gray.800" : "gray.400"}
                >
                  {liveTranscriptText ||
                    "Live transcript will appear here once recording starts with live transcription enabled."}
                </Box>
              </TabPanel>
            </TabPanels>
          </Tabs>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AudioRecorderModal;
